<template>
  <div id="app">
    <div class="top" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'center 0'}"> 

    </div>
    <label></label>
    <div style="line-height:18px;margin:20px;">
      <div>
        <label id="tip">请填写真实信息！</label>
      </div>
    </div>
   
    <label></label>
    
    <mt-field class="tiplabel"  label="姓名" style="text-align: left;" placeholder="请输入姓名" v-model="personname"></mt-field>
    <mt-field class="tiplabel"  label="身份证号" style="text-align: left;" placeholder="请输入身份证号" v-model="idnumber"></mt-field>

    <mt-button type="primary" @click="saveInfoNew" size="large">确定</mt-button>

    <br>
  </div>
  
</template>

<script>
import 'mint-ui/lib/style.css'
import Axios from 'axios'
import qs from 'qs';
import { Toast } from 'mint-ui';

export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      wxopenid:'',
      plateno:'',
      phone:'',
      roomno:'',
      ticketid:'',
      ticketname:'',
      seatno:'',
      personname:'',
      idnumber:'',
      ordertime:'',
      starttime:'',
      endtime:'',
      toastInstanse: null,
      resulttip:'',
      time:'',
      myDate:'',
      bg: require('../assets/top2.jpg')
    }
  },
  mounted(){
    // alert('find');
    this.ticketid=this.$route.params.ticketid;
    this.ticketname=this.$route.params.ticketname;
    this.seatno=this.$route.params.seatno;   
    console.log('ticket',this.ticketid); 
    console.log('seatno',this.seatno); 
  },
  methods:{
    getInfo(){
      // 验证个人信息
      var api='http://qqheapi.romis.cn/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxopenid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
        //console.log(response);     
        if(response.data.data.name!=null){
          // 渲染信息
          this.username=response.data.data.name;
          this.sex=response.data.data.sex;
          this.phone=response.data.data.tel;
          this.idnumber=response.data.data.idnumber;
        }

      }),function(err){
          console.log(err);
      }
    },
    checkIDCard(idcode){
      // 加权因子
      var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
      // 校验码
      var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

      var code = idcode + "";
      var last = idcode[17];//最后一位
      var seventeen = code.substring(0,17);
      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for(var i = 0; i < len; i++){
          num = num + arr[i] * weight_factor[i];
      }
      
      // 获取余数
      var resisue = num%11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
      第一位不可能是0
      第二位到第六位可以是0-9
      第七位到第十位是年份，所以七八位为19或者20
      十一位和十二位是月份，这两位是01-12之间的数值
      十三位和十四位是日期，是从01-31之间的数值
      十五，十六，十七都是数字0-9
      十八位可能是数字0-9，也可能是X
      */
      var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

      // 判断格式是否正确
      var format = idcard_patter.test(idcode);
      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      return last === last_no && format ? true : false;
    },
    // 验证数据的有效性
    CheckData(){
      // 验证姓名
      if(this.personname==null  || this.personname=='')
      {
        alert('请填写真实姓名');
        return false;
      }
     
      if(!this.checkIDCard(this.idnumber))
      {
        alert('身份证号不合法');
        return false;
      }      
      
      return true;
    },
    // 保存个人信息
    saveInfoNew(){
      //alert('保存基本信息');
      // 1、验证数据有效性
      if(!this.CheckData())
      {
        return;
      }
      // 2、保存数据到缓存
      localStorage.setItem('idnumber',this.idnumber);    
      localStorage.setItem('username',this.username);  
      // 3、判断如果有票信息、座位信息，则直接提交购票，无则提示保存成功
      if(this.ticketid!=null && this.seatno!=null)
      {
        this.billid = "WX0028" + this.formatDatetimeString()
                    + this.generateRandomNumber()
                    + "1"
                    + "0";
        this.ordertime=this.formattedTime();
        this.starttime=this.formattedTime();
        this.endtime=this.formattedTime();

        console.log('billid',this.billid);
        console.log('ordertime',this.ordertime);
        console.log('datetimestring',this.formatDatetimeString());
        // 直接提交购票
        var api='http://shzjapi.romis.cn:59848/api/savesalse';
        Axios.post(api,qs.stringify({
            'ticketid':this.ticketid,
            'bustype':1,
            'price':0,
            'number':1,
            'total':0,
            'billid':this.billid,
            'paytype':1,
            'ordertime':this.ordertime,
            'cardno':this.idnumber,
            'num':1,
            'starttime':this.starttime,
            'endtime':this.endtime,
            'operator':'ON-LINE',
            'mem':this.ticketname,
            'officename':'1号厅',
            'seatnumber':this.seatno,
            'name':this.personname
            }),{emulateJSON: true},{
            headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
            }).then(response=>{
            // console.log(response);
            if(response.data.result=='false'){
              // 购票失败
              this.resulttip=response.data.errmsg;
              this.show();
              return;
            }
            this.resulttip="出票成功";
            this.show();
            // 跳转到预约首页
            this.$router.push({path:'/ticketlist'});
        }),function(err){
            // 保存出错
            this.resulttip="保存信息成功";
            show();
        }
      }
      else
      {
        this.resulttip="请按正常流程购票";
        show();
      }
    },
    // 保存个人信息
    saveInfo(){
      //alert('保存基本信息');
      // 1、验证数据有效性
      if(!this.CheckData())
      {
        return;
      }
      // 2、保存数据
      var api='http://wzhcwdm.romis.cn/api/plateWhiteList';
      Axios.post(api,qs.stringify({
        'roomno':this.roomno,
        'name':this.personname,
        'plateNo':this.plateno        
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
            console.log(response);    
            if(response.data.result=="true")
            {
              this.resulttip="已加入通行名单";              
            }
            else
            {
              this.resulttip=response.data.errmsg;
            }
            // this.show();
          alert(this.resulttip);
          window.opener=null;
          window.close();
          // 信息保存成功
          //alert('保存成功');
          // 跳转到预约首页
          //this.$router.push({path:'/appointlist'});
      }),function(err){
          // 保存出错
          alert(err);
      }
    },
    show() {
      // 每当调用的时候，Toast 有一个返回值，这个返回值 重新赋值给 toastInstanse ,以至于后边手动关闭Toast
      // this.toastInstanse = Toast({
      //   message: this.resulttip, //弹窗内容
      //   position: "middle", //弹窗位置
      //   iconClass: "icon icon-success" //设置 图标类
      // });
      Toast({
        message: this.resulttip,
        position: "middle", //弹窗位置
        iconClass: 'icon icon-success'
      });

    },
    formattedTime() {
        const date = new Date();
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hour = ("0" + date.getHours()).slice(-2);
        const minute = ("0" + date.getMinutes()).slice(-2);
        const second = ("0" + date.getSeconds()).slice(-2);
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    formatDatetimeString(){
        const date = new Date();
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hour = ("0" + date.getHours()).slice(-2);
        const minute = ("0" + date.getMinutes()).slice(-2);
        const second = ("0" + date.getSeconds()).slice(-2);
        return `${year}${month}${day}${hour}${minute}${second}`;
    },
    // 生成随机的6位数字
    generateRandomNumber() {
        return Math.floor(1000 + Math.random() * 9000);
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: left; */
  color: #2c3e50;
  margin-top: 0px;
}

/* label {
        text-align:left;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
mt-popup,mt-picker{
  width: 100%;
}


.picker-center-highlight{
  background-color: #F5F5F9;
  z-index:-100;
}

sexPicker{
  width: 100%;
} */
#tip{
  color: #ee0d0d;
  text-align: center;
  display: inline-block;
}

.top {
  width: 100%;
  height: 240px;
  background-color: #0593d3;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/personinfo.vue